var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hh-btn',{staticClass:"nav-destination",attrs:{"icon-class":_vm.iconClass,"text":_vm.text,"type":_vm.type},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }